import { render, staticRenderFns } from "./WhatsappBtn.vue?vue&type=template&id=2f6e052e&"
import script from "./WhatsappBtn.vue?vue&type=script&lang=js&"
export * from "./WhatsappBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QIcon})
